import { connect } from 'react-redux';
import {
  setArtifactsMetricsInfo,
  setCaseMetricsInfo,
  setEngineMetricsInfo,
  setMetricsByDateInfo,
  setPerformanceMetricsInfo,
  modal as modalActions
} from '../actions';
import { pageTypes } from './../helpers';
import ConfirmationModalComponent
  from '../Components/ConfirmationModalComponent';
import { owners } from '../helpers/modals';
import { getModalVisibility } from './../reducers';

export const mapStateToProps = (state) => {
  const visible = getModalVisibility(state, owners.metricsByDate);
  const title = 'Confirm Select Images Run Since';
  const bodyText = 'This operation may incur a performance penalty,' +
    'as a potentially large number of records need to be loaded from the API.';
  const confirmText = 'Confirm';
  const cancelText = 'Cancel';

  return {
    visible,
    title,
    bodyText,
    confirmText,
    cancelText
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCancel: () => dispatch(modalActions.showSetMetricsByDateModal(false)),
    onConfirm: () => {
      ownProps.formCallback(ownProps.model.timestamp);
      dispatch(modalActions.showSetMetricsByDateModal(false));
      dispatch(setMetricsByDateInfo(ownProps.model));
      switch (ownProps.pageType) {
        case pageTypes.CASEMETRICS:
          dispatch(setCaseMetricsInfo(ownProps.model));
          break;
        case pageTypes.PERFORMANCEMETRICS:
          dispatch(setPerformanceMetricsInfo(ownProps.model));
          break;
        case pageTypes.ARTIFACTSMETRICS:
          dispatch(setArtifactsMetricsInfo(ownProps.model));
          break;
        case pageTypes.ENGINEMETRICS:
          dispatch(setEngineMetricsInfo(ownProps.model));
          break;
        default:
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModalComponent);



// WEBPACK FOOTER //
// src/Containers/SetMetricsByDateModalContainer.jsx